'use strict';

/**
 * @abstract
 */
bbw.model.BasePostsManager = bbw.model.BasePostManager.extend({

    subtype: undefined,
    subtypes: undefined,

    perPage: 20,

    commentPerPage: 10,
    maxCommentPerPage: 10,

    _posts: undefined,
    _rules: undefined,

    _init: function() {
        this._posts = this._constructPostCollection();
        this._configurePostsModel();
    },

    _constructPostCollection: function() {
        return this._modelFactory.create(bbw.model.PostCollection);
    },

    _configurePostsModel: function() {
        Class.abstractMethod();
    },

    _getPostsType: function() {
        Class.abstractMethod();
    },

    _getPostsScopeKey: function() {
        return 'posts';
    },

    _getScopePostsLengthPath: function() {
        return 'items.length';
    },

    _wireEntityScope: function(scope, path) {
        this._posts.wireScope(scope[path], this._getPostsScopeKey());
    },

    _getPageChangeWatchExpr: function() {
        return [this._getPostsScopeKey(), this._getScopePostsLengthPath()].join('.');
    },

    getRules: function() {
        if (angular.isDefined(this._rules)) {
            return this.$q.when(this._rules);
        } else {
            this._rules = this._modelFactory.create(bbw.model.Rules);
            return this._rules.load(this._getPostsType());
        }
    },

    hasMore: function() {
        return this._posts.hasMore();
    },

    loadMore: function() {
        return this._doLoadPosts(true);
    },

    _getDefaultSubtype: function() {
        return '';
    },

    _normalizeSubtype: function(subtype) {
        subtype = '' + subtype;
        if (subtype === '0') {
            return '';
        }
        return subtype;
    },

    _hasSubtypes: function() {
        return true;
    },

    _doInit: function() {
        if (!this._hasSubtypes()) {
            return this.$q.when();
        }

        this.subtype = this._getDefaultSubtype();
        return this._initSubtypes().then(function() {
            this.setSubtype(this._getDefaultSubtype());
        }.bind(this));
    },

    loadPosts: function(more, pages) {
        this._wasLoaded = true;
        return this._doLoadPosts(more, pages);
    },

    deletePost: function(post) {
        return this.parent.deletePost.call(this, post).then(function() {
            var postId = post.get('id');
            if (postId) {
                this._posts.unset(postId);
            }
        }.bind(this))
    },

    _doLoadPosts: function(more, pages) {
        this._isLoading = true;
        var limit = pages > 1 ? pages * this.perPage : this.perPage;
        return this._posts
            .load(this._getLoadPostsArgs(limit), more)
            .then(function(more) {
                if (!more) {
                    ngtk.tools.object.empty(this._commentsCache);
                }
            }.bind(this))
            .finally(function() {
                this._isLoading = false;
            }.bind(this));
    },

    _getLoadPostsArgs: function(limit) {
        return {
            'collection_identifier': this.subtype || undefined,
            'limit': limit
        };
    },

    updateComment: function(comment) {
        var postId = comment.get('post_id');
        var commentId = comment.get('id');
        if (!commentId) {
            return;
        }
        var existingPost;
        if (existingPost = this._posts.get(postId)) {
            this._updateComment(existingPost, comment);
        }
    },

    setSubtype: function(subtype) {
        if (angular.isUndefined(this.subtypes)) {
            throw new Error("Subtypes not loaded");
        }
        subtype = this._normalizeSubtype(subtype);
        if (subtype === '') {
            this.subtype = '';
        } else if (angular.isDefined(this.subtypes[subtype])) {
            this.subtype = subtype;
        } else {
            throw new Error("Unknown subtype: [" + subtype + "]");
        }
        return this;
    },

    watchSubtype: function(fn) {
        this._scope.$watch(this._scopePath + '.subtype', fn);
        return this;
    },

    _initSubtypes: function() {
        Class.abstractMethod();
    }

});
